import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-10" }
const _hoisted_2 = { class: "w-full h-full flex justify-start items-center mx-auto bg-green-0 overscroll-x-auto overflow-y-hidden md:hidden" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-2 bg-zinc-100 mt-2 blcok md:hidden" }, null, -1)
const _hoisted_4 = { class: "relative flex-grow flex w-full" }
const _hoisted_5 = { class: "flex pt-0 mx-auto max-w-[1280px] sm:px-4 md:px-8 2xl:px-16 w-full" }
const _hoisted_6 = { class: "flex-shrink-0 hidden pe-24 lg:block w-96" }
const _hoisted_7 = { class: "flex flex-col md:w-[768px] mx-auto w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopNavigator = _resolveComponent("TopNavigator")!
  const _component_NaviHeight = _resolveComponent("NaviHeight")!
  const _component_ColumnCategory = _resolveComponent("ColumnCategory")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Section9Footer = _resolveComponent("Section9Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_TopNavigator),
    _createVNode(_component_NaviHeight),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ColumnCategory)
      ])
    ]),
    _hoisted_3,
    _createElementVNode("main", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_ColumnCategory)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_view)
        ])
      ])
    ]),
    _createVNode(_component_Section9Footer)
  ]))
}